import {
  GET_FUND_SPOTLIGHT,
  GET_LIST_OF_STRATEGIES,
  GET_RECENT_CHAT,
  GET_MEETINGS,
  GET_RECENT_POST,
  GET_DASHBOARD_CONFIG,
  UPDATE_DASHBOARD_CONFIG,
} from "./constants";

export function getDashboardConfig(callback) {
  return {
    type: GET_DASHBOARD_CONFIG,
    callback,
  };
}
export function updateDashboardConfig(payload) {
  return {
    type: UPDATE_DASHBOARD_CONFIG,
    payload,
  };
}
export function getFundSpotlight(payload) {
  return {
    type: GET_FUND_SPOTLIGHT,
    payload,
  };
}

export function getListOfStrategies(payload) {
  return {
    type: GET_LIST_OF_STRATEGIES,
    payload,
  };
}

export function getRecentChats(payload) {
  return {
    type: GET_RECENT_CHAT,
    payload,
  };
}

export function getMeetings(payload) {
  return {
    type: GET_MEETINGS,
    payload,
  };
}

export function getRecentPost(payload) {
  return {
    type: GET_RECENT_POST,
    payload,
  };
}
